import React from 'react';
import { Shield, Users, Clock, Award } from 'lucide-react';

const SignupFeatures = () => {
  const features = [
    {
      icon: Shield,
      title: 'Safe & Secure',
      description: 'Your data is encrypted and protected with industry-leading security',
      color: '#0095fa',
    },
    {
      icon: Users,
      title: 'Connect with Community',
      description: 'Join thousands of caregivers and patients in our trusted network',
      color: '#10b981',
    },
    {
      icon: Clock,
      title: 'Flexible Scheduling',
      description: 'Create your own schedule or find care that fits your needs',
      color: '#f59e0b',
    },
    {
      icon: Award,
      title: 'Verified Professionals',
      description: 'All caregivers are background checked and verified',
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="space-y-5">
      {features.map((feature, index) => {
        const IconComponent = feature.icon;
        return (
          <div
            key={index}
            className="bg-white bg-opacity-90 rounded-2xl p-6 backdrop-blur-sm border border-white border-opacity-50 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex items-start gap-4">
              {/* Icon */}
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center text-white flex-shrink-0"
                style={{ backgroundColor: feature.color }}
              >
                <IconComponent size={24} />
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-800 mb-1" style={{ fontFamily: 'Montserrat' }}>
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            </div>
          </div>
        );
      })}

      {/* Bottom info box */}
      <div
        className="mt-8 rounded-2xl p-6 border-l-4 border-blue-500"
        style={{ backgroundColor: '#f0f4ff' }}
      >
        <p className="text-sm text-gray-700" style={{ fontFamily: 'Montserrat' }}>
          <span className="font-bold text-gray-800">Join 2,400+ caregivers</span> and{' '}
          <span className="font-bold text-gray-800">1,200+ patients</span> who trust Samah Home Care
        </p>
      </div>
    </div>
  );
};

export default SignupFeatures;